import { Box, Button, CircularProgress } from "@mui/material";

const ButtonComponent = (props: any) => {
  const {
    disable,
    isvisible,
    buttonclass,
    sx,
    variant,
    size,
    type,
    onClick,
    label,
    loader,
    ...buttonProps
  } = props;
  return (
    <Box style={{ display: isvisible === "true" ? "none" : "block" }}>
      <Button
        className={buttonclass}
        sx={sx}
        variant={variant ? variant : "contained"}
        size={size ? size : "small"}
        type={type ? type : "submit"}
        onClick={onClick}
        disabled={disable ? disable : false}
        {...buttonProps}
      >
       {loader && disable && <CircularProgress disableShrink  size={12} sx={{margin:"5px"}} />} {label}
      </Button>
    </Box>
  );
};

export default ButtonComponent;
